import React from 'react'
import { Icon } from './FastCoverage.elements'

type Props = {
  className?: string
}

export const FastCoverageIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 33 32"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M8.695 10.085l-1.3-1.3" stroke="#C7E7FF" strokeWidth="1.5" />
    <circle cx="16.491" cy="17.939" r="9.644" stroke="#C7E7FF" strokeWidth="1.5" />
    <circle cx="16.505" cy="17.836" r="1.199" transform="rotate(90 16.505 17.836)" stroke="#C7E7FF" strokeWidth="1.5" />
    <path d="M11.493 20.48l3.58-2.067M8.695 7.487l-2.598 2.598M13.242 3.648h6.496v1.299h-6.496zM17.79 6.896V4.947h-2.6v1.949" stroke="#C7E7FF" strokeWidth="1.5" />
    <path d="M24.486 30.204a6.218 6.218 0 100-12.437 6.218 6.218 0 000 12.437z" fill="#173A68" />
    <g clipPath="url(#clip-fast-coverage)" stroke="#4CA9ED" strokeWidth="1.5">
      <path d="M24.5 28.8a4.8 4.8 0 100-9.6 4.8 4.8 0 000 9.6zM24.5 20.8v4.267M24.5 25.6v1.6" />
    </g>
    <defs>
      <clipPath id="clip-fast-coverage">
        <path fill="#fff" transform="translate(18.1 17.6)" d="M0 0h12.8v12.8H0z" />
      </clipPath>
    </defs>
  </Icon>
)
